import { render, staticRenderFns } from "./dropdown-list-v2.vue?vue&type=template&id=6ebb4e24&scoped=true&"
import script from "./dropdown-list-v2.vue?vue&type=script&lang=js&"
export * from "./dropdown-list-v2.vue?vue&type=script&lang=js&"
import style0 from "./dropdown-list-v2.vue?vue&type=style&index=0&id=6ebb4e24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebb4e24",
  null
  
)

export default component.exports